export default "__VITE_ASSET__3cca9d97__"